module.exports = __webpack_public_path__ + "static/SkipLogic-37e3eb0d3e0796f24c85324eee07b289.gif";